module.exports = __webpack_public_path__ + "prod/1.42.2/img/obj_guarantee2x.3ed98146.png";